/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
 
import styles from '../styles/linkfooter.module.scss'
import { GetEULALink, GetGDPRLink, GetHomeLink, GetImpressumLink } from '../helpers/helpers';
import { CountryData } from '../store/interfaces';
 
interface LinkFooterProps {
    country: CountryData;
    fullWidth?: boolean;
    children?: ReactElement;
    className?: string;
}
  
export function LinkFooter(props: LinkFooterProps) {
    const {t} = useTranslation();
    var style : React.CSSProperties = {};
    if(props.fullWidth === true) {
        style.justifyContent = 'space-between';
    }
    return (
        <div className={`${styles.container} ${props.className !== undefined ? props.className : ''}`} style={style}>
            <a className={styles.link} href={GetHomeLink(props.country)} target={'_blank'} rel="noreferrer">{t('linkfooter.home')}</a>
            <a className={styles.link} href={GetGDPRLink(props.country)} target={'_blank'} rel="noreferrer">{t('linkfooter.gdpr')}</a>
            <a className={styles.link} href="#" onClick={() => {
                //@ts-ignore
                ppms.cm.api('openConsentForm', ()=>{},  ()=>{});
            }
            }>{t('linkfooter.cookie')}</a>
            <a className={styles.link} href={GetEULALink(props.country)} target={'_blank'} rel="noreferrer">{t('linkfooter.eula')}</a>
            <a className={styles.link} href={GetImpressumLink(props.country)} target={'_blank'} rel="noreferrer">{t('linkfooter.impressum')}</a>
            {props.children}
        </div>
    );
};
 